import { useTranslation } from 'react-i18next';
import Modal from '../common/Modal';

const DeleteModal = ({ isShow, onClose, onSubmit }) => {
    const { t } = useTranslation();

    return (
        <Modal
            size="sm"
            isShow={isShow}
            onClose={onClose}
            isShowIconClose="true"
            title={t('modal.common_modal.title')}
            btnList={[
                {
                    name: t('button.delete'),
                    className: 'btn--primary',
                    onClick: onSubmit,
                    disabled: false,
                },
                {
                    name: t('button.cancel'),
                    className: 'btn--secondary',
                    onClick: onClose,
                    disabled: false,
                },
            ]}
            children={
                <>
                    <p className="text-center">こちら本当に削除しますか？</p>
                </>
            }
        />
    );
};

export default DeleteModal;
